import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Navbar.module.css';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const current = i18n.language || localStorage.getItem('i18nextLng') || 'ru';

  const setLang = (lng: string) => {
    i18n.changeLanguage(lng);
    try { localStorage.setItem('i18nextLng', lng); } catch (e) {}
  };

  return (
    <div className={styles.langs}>
      {['ru','kz','tr'].map((lng) => (
        <button
          key={lng}
          type="button"
          onClick={() => setLang(lng)}
          className={`${styles.langBtn} ${current.startsWith(lng) ? styles.langBtnActive : ''}`}
          aria-pressed={current.startsWith(lng)}
        >
          {lng.toUpperCase()}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
